import apiTrainingGroups from '@/api/training-groups'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteTrainingGroupStart:
    '[delete training group] Delete training group start',
  deleteTrainingGroupSuccess:
    '[delete training group] Delete training group success',
  deleteTrainingGroupFailure:
    '[delete training group] Delete training group failure'
}

export const actionTypes = {
  deleteTrainingGroup: '[delete training group] Delete training group'
}

const mutations = {
  [mutationTypes.deleteTrainingGroupStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteTrainingGroupSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteTrainingGroupFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteTrainingGroup](context, {id}) {
    context.commit(mutationTypes.deleteTrainingGroupStart)
    return new Promise(resolve => {
      apiTrainingGroups
        .deleteTrainingGroup(id)
        .then(response => {
          context.commit(mutationTypes.deleteTrainingGroupSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteTrainingGroupFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
